export default function() {
   return {
      companies: [],
      loaded: false,
      fetching: false,
      updating: [],
      priority_definitions: [],
      priorities_updating: [],
      capacities_updating: [],
   };
}
